﻿/**
 * Footer Email + SMS subscribe
 * Business (2026-09):
 * - Write to Shopify first; Shopify syncs to Cartsee (CS). Do NOT call Cartsee OpenAPI from theme.
 * - Email: Shopify customer form (no consent checkbox)
 * - SMS: submit directly in Footer (not CS popup); consent checkbox required; format check only (no OTP)
 * - Success: show NEW15 coupon per channel
 */
(function () {
  'use strict';

  /*
   * 完整国家码列表（对齐 SX/Klaviyo intl）：字母序，可用 Search 筛选
   * 默认选中 US
   */
  var COUNTRIES = [
    { iso: 'AF', name: 'Afghanistan', dial: '+93' },
    { iso: 'AX', name: 'Åland Islands', dial: '+358' },
    { iso: 'AL', name: 'Albania', dial: '+355' },
    { iso: 'DZ', name: 'Algeria', dial: '+213' },
    { iso: 'AS', name: 'American Samoa', dial: '+1' },
    { iso: 'AD', name: 'Andorra', dial: '+376' },
    { iso: 'AO', name: 'Angola', dial: '+244' },
    { iso: 'AI', name: 'Anguilla', dial: '+1' },
    { iso: 'AG', name: 'Antigua and Barbuda', dial: '+1' },
    { iso: 'AR', name: 'Argentina', dial: '+54' },
    { iso: 'AM', name: 'Armenia', dial: '+374' },
    { iso: 'AW', name: 'Aruba', dial: '+297' },
    { iso: 'AU', name: 'Australia', dial: '+61' },
    { iso: 'AT', name: 'Austria', dial: '+43' },
    { iso: 'AZ', name: 'Azerbaijan', dial: '+994' },
    { iso: 'BS', name: 'Bahamas', dial: '+1' },
    { iso: 'BH', name: 'Bahrain', dial: '+973' },
    { iso: 'BD', name: 'Bangladesh', dial: '+880' },
    { iso: 'BB', name: 'Barbados', dial: '+1' },
    { iso: 'BY', name: 'Belarus', dial: '+375' },
    { iso: 'BE', name: 'Belgium', dial: '+32' },
    { iso: 'BZ', name: 'Belize', dial: '+501' },
    { iso: 'BJ', name: 'Benin', dial: '+229' },
    { iso: 'BM', name: 'Bermuda', dial: '+1' },
    { iso: 'BT', name: 'Bhutan', dial: '+975' },
    { iso: 'BO', name: 'Bolivia', dial: '+591' },
    { iso: 'BA', name: 'Bosnia and Herzegovina', dial: '+387' },
    { iso: 'BW', name: 'Botswana', dial: '+267' },
    { iso: 'BR', name: 'Brazil', dial: '+55' },
    { iso: 'IO', name: 'British Indian Ocean Territory', dial: '+246' },
    { iso: 'VG', name: 'British Virgin Islands', dial: '+1' },
    { iso: 'BN', name: 'Brunei', dial: '+673' },
    { iso: 'BG', name: 'Bulgaria', dial: '+359' },
    { iso: 'BF', name: 'Burkina Faso', dial: '+226' },
    { iso: 'BI', name: 'Burundi', dial: '+257' },
    { iso: 'KH', name: 'Cambodia', dial: '+855' },
    { iso: 'CM', name: 'Cameroon', dial: '+237' },
    { iso: 'CA', name: 'Canada', dial: '+1' },
    { iso: 'CV', name: 'Cape Verde', dial: '+238' },
    { iso: 'KY', name: 'Cayman Islands', dial: '+1' },
    { iso: 'CF', name: 'Central African Republic', dial: '+236' },
    { iso: 'TD', name: 'Chad', dial: '+235' },
    { iso: 'CL', name: 'Chile', dial: '+56' },
    { iso: 'CN', name: 'China', dial: '+86' },
    { iso: 'CX', name: 'Christmas Island', dial: '+61' },
    { iso: 'CC', name: 'Cocos Islands', dial: '+61' },
    { iso: 'CO', name: 'Colombia', dial: '+57' },
    { iso: 'KM', name: 'Comoros', dial: '+269' },
    { iso: 'CG', name: 'Congo', dial: '+242' },
    { iso: 'CD', name: 'Congo (DRC)', dial: '+243' },
    { iso: 'CK', name: 'Cook Islands', dial: '+682' },
    { iso: 'CR', name: 'Costa Rica', dial: '+506' },
    { iso: 'CI', name: "Côte d'Ivoire", dial: '+225' },
    { iso: 'HR', name: 'Croatia', dial: '+385' },
    { iso: 'CU', name: 'Cuba', dial: '+53' },
    { iso: 'CW', name: 'Curaçao', dial: '+599' },
    { iso: 'CY', name: 'Cyprus', dial: '+357' },
    { iso: 'CZ', name: 'Czech Republic', dial: '+420' },
    { iso: 'DK', name: 'Denmark', dial: '+45' },
    { iso: 'DJ', name: 'Djibouti', dial: '+253' },
    { iso: 'DM', name: 'Dominica', dial: '+1' },
    { iso: 'DO', name: 'Dominican Republic', dial: '+1' },
    { iso: 'EC', name: 'Ecuador', dial: '+593' },
    { iso: 'EG', name: 'Egypt', dial: '+20' },
    { iso: 'SV', name: 'El Salvador', dial: '+503' },
    { iso: 'GQ', name: 'Equatorial Guinea', dial: '+240' },
    { iso: 'ER', name: 'Eritrea', dial: '+291' },
    { iso: 'EE', name: 'Estonia', dial: '+372' },
    { iso: 'SZ', name: 'Eswatini', dial: '+268' },
    { iso: 'ET', name: 'Ethiopia', dial: '+251' },
    { iso: 'FK', name: 'Falkland Islands', dial: '+500' },
    { iso: 'FO', name: 'Faroe Islands', dial: '+298' },
    { iso: 'FJ', name: 'Fiji', dial: '+679' },
    { iso: 'FI', name: 'Finland', dial: '+358' },
    { iso: 'FR', name: 'France', dial: '+33' },
    { iso: 'GF', name: 'French Guiana', dial: '+594' },
    { iso: 'PF', name: 'French Polynesia', dial: '+689' },
    { iso: 'GA', name: 'Gabon', dial: '+241' },
    { iso: 'GM', name: 'Gambia', dial: '+220' },
    { iso: 'GE', name: 'Georgia', dial: '+995' },
    { iso: 'DE', name: 'Germany', dial: '+49' },
    { iso: 'GH', name: 'Ghana', dial: '+233' },
    { iso: 'GI', name: 'Gibraltar', dial: '+350' },
    { iso: 'GR', name: 'Greece', dial: '+30' },
    { iso: 'GL', name: 'Greenland', dial: '+299' },
    { iso: 'GD', name: 'Grenada', dial: '+1' },
    { iso: 'GP', name: 'Guadeloupe', dial: '+590' },
    { iso: 'GU', name: 'Guam', dial: '+1' },
    { iso: 'GT', name: 'Guatemala', dial: '+502' },
    { iso: 'GG', name: 'Guernsey', dial: '+44' },
    { iso: 'GN', name: 'Guinea', dial: '+224' },
    { iso: 'GW', name: 'Guinea-Bissau', dial: '+245' },
    { iso: 'GY', name: 'Guyana', dial: '+592' },
    { iso: 'HT', name: 'Haiti', dial: '+509' },
    { iso: 'HN', name: 'Honduras', dial: '+504' },
    { iso: 'HK', name: 'Hong Kong', dial: '+852' },
    { iso: 'HU', name: 'Hungary', dial: '+36' },
    { iso: 'IS', name: 'Iceland', dial: '+354' },
    { iso: 'IN', name: 'India', dial: '+91' },
    { iso: 'ID', name: 'Indonesia', dial: '+62' },
    { iso: 'IR', name: 'Iran', dial: '+98' },
    { iso: 'IQ', name: 'Iraq', dial: '+964' },
    { iso: 'IE', name: 'Ireland', dial: '+353' },
    { iso: 'IM', name: 'Isle of Man', dial: '+44' },
    { iso: 'IL', name: 'Israel', dial: '+972' },
    { iso: 'IT', name: 'Italy', dial: '+39' },
    { iso: 'JM', name: 'Jamaica', dial: '+1' },
    { iso: 'JP', name: 'Japan', dial: '+81' },
    { iso: 'JE', name: 'Jersey', dial: '+44' },
    { iso: 'JO', name: 'Jordan', dial: '+962' },
    { iso: 'KZ', name: 'Kazakhstan', dial: '+7' },
    { iso: 'KE', name: 'Kenya', dial: '+254' },
    { iso: 'KI', name: 'Kiribati', dial: '+686' },
    { iso: 'XK', name: 'Kosovo', dial: '+383' },
    { iso: 'KW', name: 'Kuwait', dial: '+965' },
    { iso: 'KG', name: 'Kyrgyzstan', dial: '+996' },
    { iso: 'LA', name: 'Laos', dial: '+856' },
    { iso: 'LV', name: 'Latvia', dial: '+371' },
    { iso: 'LB', name: 'Lebanon', dial: '+961' },
    { iso: 'LS', name: 'Lesotho', dial: '+266' },
    { iso: 'LR', name: 'Liberia', dial: '+231' },
    { iso: 'LY', name: 'Libya', dial: '+218' },
    { iso: 'LI', name: 'Liechtenstein', dial: '+423' },
    { iso: 'LT', name: 'Lithuania', dial: '+370' },
    { iso: 'LU', name: 'Luxembourg', dial: '+352' },
    { iso: 'MO', name: 'Macao', dial: '+853' },
    { iso: 'MG', name: 'Madagascar', dial: '+261' },
    { iso: 'MW', name: 'Malawi', dial: '+265' },
    { iso: 'MY', name: 'Malaysia', dial: '+60' },
    { iso: 'MV', name: 'Maldives', dial: '+960' },
    { iso: 'ML', name: 'Mali', dial: '+223' },
    { iso: 'MT', name: 'Malta', dial: '+356' },
    { iso: 'MH', name: 'Marshall Islands', dial: '+692' },
    { iso: 'MQ', name: 'Martinique', dial: '+596' },
    { iso: 'MR', name: 'Mauritania', dial: '+222' },
    { iso: 'MU', name: 'Mauritius', dial: '+230' },
    { iso: 'YT', name: 'Mayotte', dial: '+262' },
    { iso: 'MX', name: 'Mexico', dial: '+52' },
    { iso: 'FM', name: 'Micronesia', dial: '+691' },
    { iso: 'MD', name: 'Moldova', dial: '+373' },
    { iso: 'MC', name: 'Monaco', dial: '+377' },
    { iso: 'MN', name: 'Mongolia', dial: '+976' },
    { iso: 'ME', name: 'Montenegro', dial: '+382' },
    { iso: 'MS', name: 'Montserrat', dial: '+1' },
    { iso: 'MA', name: 'Morocco', dial: '+212' },
    { iso: 'MZ', name: 'Mozambique', dial: '+258' },
    { iso: 'MM', name: 'Myanmar', dial: '+95' },
    { iso: 'NA', name: 'Namibia', dial: '+264' },
    { iso: 'NR', name: 'Nauru', dial: '+674' },
    { iso: 'NP', name: 'Nepal', dial: '+977' },
    { iso: 'NL', name: 'Netherlands', dial: '+31' },
    { iso: 'NC', name: 'New Caledonia', dial: '+687' },
    { iso: 'NZ', name: 'New Zealand', dial: '+64' },
    { iso: 'NI', name: 'Nicaragua', dial: '+505' },
    { iso: 'NE', name: 'Niger', dial: '+227' },
    { iso: 'NG', name: 'Nigeria', dial: '+234' },
    { iso: 'NU', name: 'Niue', dial: '+683' },
    { iso: 'NF', name: 'Norfolk Island', dial: '+672' },
    { iso: 'KP', name: 'North Korea', dial: '+850' },
    { iso: 'MK', name: 'North Macedonia', dial: '+389' },
    { iso: 'MP', name: 'Northern Mariana Islands', dial: '+1' },
    { iso: 'NO', name: 'Norway', dial: '+47' },
    { iso: 'OM', name: 'Oman', dial: '+968' },
    { iso: 'PK', name: 'Pakistan', dial: '+92' },
    { iso: 'PW', name: 'Palau', dial: '+680' },
    { iso: 'PS', name: 'Palestine', dial: '+970' },
    { iso: 'PA', name: 'Panama', dial: '+507' },
    { iso: 'PG', name: 'Papua New Guinea', dial: '+675' },
    { iso: 'PY', name: 'Paraguay', dial: '+595' },
    { iso: 'PE', name: 'Peru', dial: '+51' },
    { iso: 'PH', name: 'Philippines', dial: '+63' },
    { iso: 'PL', name: 'Poland', dial: '+48' },
    { iso: 'PT', name: 'Portugal', dial: '+351' },
    { iso: 'PR', name: 'Puerto Rico', dial: '+1' },
    { iso: 'QA', name: 'Qatar', dial: '+974' },
    { iso: 'RE', name: 'Réunion', dial: '+262' },
    { iso: 'RO', name: 'Romania', dial: '+40' },
    { iso: 'RU', name: 'Russia', dial: '+7' },
    { iso: 'RW', name: 'Rwanda', dial: '+250' },
    { iso: 'BL', name: 'Saint Barthélemy', dial: '+590' },
    { iso: 'SH', name: 'Saint Helena', dial: '+290' },
    { iso: 'KN', name: 'Saint Kitts and Nevis', dial: '+1' },
    { iso: 'LC', name: 'Saint Lucia', dial: '+1' },
    { iso: 'MF', name: 'Saint Martin', dial: '+590' },
    { iso: 'PM', name: 'Saint Pierre and Miquelon', dial: '+508' },
    { iso: 'VC', name: 'Saint Vincent and the Grenadines', dial: '+1' },
    { iso: 'WS', name: 'Samoa', dial: '+685' },
    { iso: 'SM', name: 'San Marino', dial: '+378' },
    { iso: 'ST', name: 'São Tomé and Príncipe', dial: '+239' },
    { iso: 'SA', name: 'Saudi Arabia', dial: '+966' },
    { iso: 'SN', name: 'Senegal', dial: '+221' },
    { iso: 'RS', name: 'Serbia', dial: '+381' },
    { iso: 'SC', name: 'Seychelles', dial: '+248' },
    { iso: 'SL', name: 'Sierra Leone', dial: '+232' },
    { iso: 'SG', name: 'Singapore', dial: '+65' },
    { iso: 'SX', name: 'Sint Maarten', dial: '+1' },
    { iso: 'SK', name: 'Slovakia', dial: '+421' },
    { iso: 'SI', name: 'Slovenia', dial: '+386' },
    { iso: 'SB', name: 'Solomon Islands', dial: '+677' },
    { iso: 'SO', name: 'Somalia', dial: '+252' },
    { iso: 'ZA', name: 'South Africa', dial: '+27' },
    { iso: 'KR', name: 'South Korea', dial: '+82' },
    { iso: 'SS', name: 'South Sudan', dial: '+211' },
    { iso: 'ES', name: 'Spain', dial: '+34' },
    { iso: 'LK', name: 'Sri Lanka', dial: '+94' },
    { iso: 'SD', name: 'Sudan', dial: '+249' },
    { iso: 'SR', name: 'Suriname', dial: '+597' },
    { iso: 'SJ', name: 'Svalbard and Jan Mayen', dial: '+47' },
    { iso: 'SE', name: 'Sweden', dial: '+46' },
    { iso: 'CH', name: 'Switzerland', dial: '+41' },
    { iso: 'SY', name: 'Syria', dial: '+963' },
    { iso: 'TW', name: 'Taiwan', dial: '+886' },
    { iso: 'TJ', name: 'Tajikistan', dial: '+992' },
    { iso: 'TZ', name: 'Tanzania', dial: '+255' },
    { iso: 'TH', name: 'Thailand', dial: '+66' },
    { iso: 'TL', name: 'Timor-Leste', dial: '+670' },
    { iso: 'TG', name: 'Togo', dial: '+228' },
    { iso: 'TK', name: 'Tokelau', dial: '+690' },
    { iso: 'TO', name: 'Tonga', dial: '+676' },
    { iso: 'TT', name: 'Trinidad and Tobago', dial: '+1' },
    { iso: 'TN', name: 'Tunisia', dial: '+216' },
    { iso: 'TR', name: 'Turkey', dial: '+90' },
    { iso: 'TM', name: 'Turkmenistan', dial: '+993' },
    { iso: 'TC', name: 'Turks and Caicos Islands', dial: '+1' },
    { iso: 'TV', name: 'Tuvalu', dial: '+688' },
    { iso: 'VI', name: 'U.S. Virgin Islands', dial: '+1' },
    { iso: 'UG', name: 'Uganda', dial: '+256' },
    { iso: 'UA', name: 'Ukraine', dial: '+380' },
    { iso: 'AE', name: 'United Arab Emirates', dial: '+971' },
    { iso: 'GB', name: 'United Kingdom', dial: '+44' },
    { iso: 'US', name: 'United States', dial: '+1' },
    { iso: 'UY', name: 'Uruguay', dial: '+598' },
    { iso: 'UZ', name: 'Uzbekistan', dial: '+998' },
    { iso: 'VU', name: 'Vanuatu', dial: '+678' },
    { iso: 'VA', name: 'Vatican City', dial: '+39' },
    { iso: 'VE', name: 'Venezuela', dial: '+58' },
    { iso: 'VN', name: 'Vietnam', dial: '+84' },
    { iso: 'WF', name: 'Wallis and Futuna', dial: '+681' },
    { iso: 'EH', name: 'Western Sahara', dial: '+212' },
    { iso: 'YE', name: 'Yemen', dial: '+967' },
    { iso: 'ZM', name: 'Zambia', dial: '+260' },
    { iso: 'ZW', name: 'Zimbabwe', dial: '+263' }
  ];

  var DEFAULT_COUNTRY =
    COUNTRIES.find(function (c) {
      return c.iso === 'US';
    }) || COUNTRIES[0];

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function isValidPhone(national, dial) {
    var digits = digitsOnly(national);
    if (digits.length < 7 || digits.length > 15) return false;
    // US/CA: expect 10-digit national number
    if (dial === '+1' && digits.length !== 10) return false;
    return true;
  }

  
  function toE164(dial, national) {
    var code = String(dial || '').replace(/\D/g, '');
    var local = digitsOnly(national);
    if (!code || !local) return '';
    if (local.indexOf(code) === 0 && local.length > code.length + 5) {
      return '+' + local;
    }
    return '+' + code + local;
  }

  var STORAGE_CHANNEL = 'pl_footer_subscribe_channel';
  var STORAGE_EMAIL_DONE = 'pl_footer_subscribe_email_done';
  var STORAGE_SMS_DONE = 'pl_footer_subscribe_sms_done';

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key) || window.localStorage.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function storageSet(key, value, sessionOnly) {
    try {
      if (sessionOnly) window.sessionStorage.setItem(key, value);
      else window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (e) {}
  }

  function trackFooterSubscribe(channel) {
    try {
      if (!window.dataLayer) return;
      window.dataLayer.push({
        event: 'subscription_submitted',
        button_position: 'Footer',
        subscribe_channel: channel
      });
    } catch (e) {}
  }

  function setButtonBusy(btn, busy, forceDisabled) {
    if (!btn) return;
    if (busy) {
      btn.disabled = true;
    } else if (typeof forceDisabled === 'boolean') {
      btn.disabled = forceDisabled;
    } else {
      btn.disabled = false;
    }
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function initWidget(root) {
    if (!root || root.dataset.footerSubscribeReady === 'true') return;
    root.dataset.footerSubscribeReady = 'true';

    var couponCode = root.getAttribute('data-coupon-code') || 'NEW15';
    var formState = root.querySelector('[data-subscribe-form]');
    var successState = root.querySelector('[data-subscribe-success]');
    var emailInput = root.querySelector('[data-email-input]');
    var emailSubmit = root.querySelector('[data-email-submit]');
    var emailError = root.querySelector('[data-email-error]');
    var phoneInput = root.querySelector('[data-phone-input]');
    var smsSubmit = root.querySelector('[data-sms-submit]');
    var phoneError = root.querySelector('[data-phone-error]');
    var consent = root.querySelector('[data-sms-consent]');
    var couponEmail = root.querySelector('[data-coupon-email]');
    var couponSms = root.querySelector('[data-coupon-sms]');
    var emailRow = root.querySelector('[data-email-row]');
    var phoneRow = root.querySelector('[data-phone-row]');
    var consentLabel = root.querySelector('.footer-subscribe__consent');

    var countryToggle = root.querySelector('[data-country-toggle]');
    var countryPanel = root.querySelector('[data-country-panel]');
    var countrySearch = root.querySelector('[data-country-search]');
    var countryList = root.querySelector('[data-country-list]');
    var countryFlag = root.querySelector('[data-country-flag]');
    var countryDial = root.querySelector('[data-country-dial]');

    var emailForm = root.querySelector(root.getAttribute('data-email-form') || '#footer-subscribe-email-form');
    var smsForm = root.querySelector(root.getAttribute('data-sms-form') || '#footer-subscribe-sms-form');
    var selected = DEFAULT_COUNTRY;

    /*
      真正原生提交：按钮 type=submit，校验失败才 preventDefault。
      不要 JS 调 form.submit()/fetch，否则 Shopify hCaptcha 会 Invalid/Missing token，后台无客。
    */
    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        var value = ((emailInput && emailInput.value) || '').trim();
        if (!EMAIL_RE.test(value)) {
          e.preventDefault();
          setError(emailError, 'Please enter a valid email address.');
          return;
        }
        setError(emailError, '');
        storageSet(STORAGE_CHANNEL, 'email', true);
        setButtonBusy(emailSubmit, true);
        // 放行浏览器原生 POST /contact
      });
    }
    if (smsForm) {
      smsForm.addEventListener('submit', function (e) {
        if (!consent || !consent.checked) {
          e.preventDefault();
          setError(phoneError, 'Please agree to receive marketing text messages.');
          return;
        }
        var national = (phoneInput && phoneInput.value) || '';
        if (!isValidPhone(national, selected.dial)) {
          e.preventDefault();
          setError(phoneError, 'Please enter a valid phone number.');
          return;
        }

        var e164 = toE164(selected.dial, national);
        var hiddenPhone = smsForm.querySelector('[data-shopify-phone-input]');
        var hiddenSmsEmail = smsForm.querySelector('[data-shopify-sms-email-input]');
        if (!hiddenPhone || !hiddenSmsEmail) {
          e.preventDefault();
          setError(phoneError, 'Subscribe unavailable. Please refresh and try again.');
          return;
        }

        var shopDomain = root.getAttribute('data-shop-domain') || 'shop.myshopify.com';
        hiddenPhone.value = e164;
        hiddenSmsEmail.value = 'sms.' + digitsOnly(e164) + '@' + shopDomain;
        setError(phoneError, '');
        storageSet(STORAGE_CHANNEL, 'sms', true);
        setButtonBusy(smsSubmit, true, true);
      });
    }

    var emailDone = storageGet(STORAGE_EMAIL_DONE) === '1';
    var smsDone = storageGet(STORAGE_SMS_DONE) === '1';

    // 仅当 Shopify 回跳 customer_posted=true 才算成功（后台才会有客户）
    try {
      var params = new URLSearchParams(window.location.search || '');
      if (params.get('customer_posted') === 'true') {
        var pending = storageGet(STORAGE_CHANNEL);
        storageRemove(STORAGE_CHANNEL);
        if (pending === 'sms') {
          smsDone = true;
          storageSet(STORAGE_SMS_DONE, '1');
          trackFooterSubscribe('sms');
        } else if (pending === 'email') {
          emailDone = true;
          storageSet(STORAGE_EMAIL_DONE, '1');
          trackFooterSubscribe('email');
        }
        if (window.history && window.history.replaceState) {
          var clean =
            window.location.pathname +
            (window.location.hash || '#footer-subscribe-email-form');
          window.history.replaceState({}, '', clean);
        }
      }
    } catch (e) {}

    function setError(el, message) {
      if (!el) return;
      if (message) {
        el.textContent = message;
        el.style.setProperty('color', '#e00000', 'important');
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    }

    function syncSmsButton() {
      if (!smsSubmit) return;
      smsSubmit.disabled = !(consent && consent.checked);
    }

    function showSuccessPartial() {
      if (!successState || !formState) return;

      if (couponEmail) couponEmail.hidden = !emailDone;
      if (couponSms) couponSms.hidden = !smsDone;
      successState.hidden = !(emailDone || smsDone);

      if (emailRow) emailRow.hidden = !!emailDone;
      if (emailError) emailError.hidden = true;
      if (phoneRow) phoneRow.hidden = !!smsDone;
      if (phoneError) phoneError.hidden = true;
      if (consentLabel) consentLabel.hidden = !!smsDone;

      formState.hidden = !!(emailDone && smsDone);
    }

    showSuccessPartial();

    function flagClass(iso) {
      return 'currency-flag currency-flag--' + String(iso || 'us').toLowerCase();
    }

    function updateFlagEl(el, iso) {
      if (!el) return;
      el.className = flagClass(iso);
      el.setAttribute('data-country-flag', '');
      el.setAttribute('aria-hidden', 'true');
    }

    function renderCountries(filter) {
      if (!countryList) return;
      var q = String(filter || '').trim().toLowerCase();
      countryList.innerHTML = '';
      COUNTRIES.forEach(function (c) {
        var iso = c.iso || '';
        var name = c.name || '';
        var dial = c.dial || '';
        var hay = (name + ' ' + dial + ' ' + iso).toLowerCase();
        if (q && hay.indexOf(q) === -1) return;

        var li = document.createElement('li');
        li.className = 'footer-subscribe__country-item';
        li.setAttribute('role', 'option');
        li.setAttribute('data-iso', iso);

        var flag = document.createElement('span');
        flag.className = flagClass(iso);
        flag.setAttribute('aria-hidden', 'true');

        var nameEl = document.createElement('span');
        nameEl.className = 'footer-subscribe__country-name';
        nameEl.textContent = name;

        var dialEl = document.createElement('span');
        dialEl.className = 'footer-subscribe__country-dial';
        dialEl.textContent = dial;

        li.appendChild(flag);
        li.appendChild(nameEl);
        li.appendChild(dialEl);
        countryList.appendChild(li);
      });
    }

    function setCountry(c) {
      if (!c) return;
      selected = c;
      updateFlagEl(countryFlag, c.iso);
      if (countryDial) countryDial.textContent = c.dial || '';
      if (countryToggle) {
        countryToggle.setAttribute(
          'aria-label',
          'Select country code ' + (c.dial || '')
        );
      }
      closeCountry();
    }

    function openCountry() {
      if (!countryPanel || !countryToggle) return;
      countryPanel.hidden = false;
      countryToggle.setAttribute('aria-expanded', 'true');
      countryToggle.classList.add('is-open');
      if (countrySearch) countrySearch.value = '';
      renderCountries('');
      if (countrySearch) {
        window.requestAnimationFrame(function () {
          countrySearch.focus();
        });
      }
    }

    function closeCountry() {
      if (!countryPanel || !countryToggle) return;
      countryPanel.hidden = true;
      countryToggle.setAttribute('aria-expanded', 'false');
      countryToggle.classList.remove('is-open');
    }

    if (consent) {
      consent.addEventListener('change', syncSmsButton);
    }
    syncSmsButton();

    /* 点击国旗/小三角：开关下拉；三角随 is-open 旋转 */
    if (countryToggle) {
      countryToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (countryPanel && countryPanel.hidden) openCountry();
        else closeCountry();
      });
    }

    if (countryPanel) {
      countryPanel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    if (countrySearch) {
      countrySearch.addEventListener('input', function () {
        renderCountries(countrySearch.value);
      });
      countrySearch.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeCountry();
          if (countryToggle) countryToggle.focus();
        }
        // 避免 Search 回车误提交整表
        if (e.key === 'Enter') e.preventDefault();
      });
    }

    /* 选中国家后关闭下拉 */
    if (countryList) {
      countryList.addEventListener('click', function (e) {
        var item = e.target.closest('[data-iso]');
        if (!item) return;
        e.preventDefault();
        e.stopPropagation();
        var iso = item.getAttribute('data-iso');
        var found = COUNTRIES.find(function (c) {
          return c.iso === iso;
        });
        if (found) setCountry(found);
      });
    }

    /* 点击区域外关闭下拉（capture 更稳） */
    document.addEventListener(
      'pointerdown',
      function (e) {
        if (!countryPanel || countryPanel.hidden) return;
        var t = e.target;
        if (countryToggle && countryToggle.contains(t)) return;
        if (countryPanel.contains(t)) return;
        closeCountry();
      },
      true
    );

    root.querySelectorAll('[data-copy-coupon]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var text = couponCode;
        var done = function () {
          btn.classList.add('is-copied');
          btn.setAttribute('aria-label', 'Copied');
          setTimeout(function () {
            btn.classList.remove('is-copied');
            btn.setAttribute('aria-label', 'Copy coupon code');
          }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(function () {
            fallbackCopy(text);
            done();
          });
        } else {
          fallbackCopy(text);
          done();
        }
      });
    });

    root.querySelectorAll('[data-coupon-display]').forEach(function (el) {
      el.textContent = couponCode;
    });

    renderCountries('');
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    document.body.removeChild(ta);
  }

  function initAll() {
    document.querySelectorAll('[data-footer-subscribe]').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

